import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { Box, Divider } from "@mui/material";
import SidebarDrawer from "./SidebarDrawer";
import { setToggleSideBar } from "../../store/slices/filterSlice";

import DateRangeFilter from "../Filter/DateRangeFilter";
import GenericFilter from "../Filter/GenericFilter";
import { useSidebarFilters } from "./useSidebarFilter.hook";

const SidebarContainer = () => {
  const { openSideBar, selectedFilter } = useSelector(
    (state: RootState) => state.filter
  );
  const dispatch = useDispatch<AppDispatch>();

  const toggleFilter = () => dispatch(setToggleSideBar(!openSideBar));

  //Local filter implementation
  const {
    localFilter,
    setLocalFilter,
    applyFilters,
    distinctRegions,
    affiliateNames,
    risks,
    distinctEvaluations,
    distinctStatus,
    distinctProducts,
    distinctSampleId,
  } = useSidebarFilters(selectedFilter);

  const filterConfigs = [
    {
      title: "Region",
      filterKey: "selectedRegions",
      options: distinctRegions as string[],
      isSearchable: true,
    },
    {
      title: "Country",
      filterKey: "selectedCountries",
      options: affiliateNames as string[],
      isSearchable: true,
      isVirtualized: true,
    },
    {
      title: "Affiliate",
      filterKey: "selectedAffiliates",
      options: affiliateNames || ([] as string[]),
      isSearchable: true,
      isVirtualized: true,
    },
    {
      title: "Risk Type",
      filterKey: "selectedRisk",
      options: risks.riskValues as string[],
      optionLabelMap: risks.riskLabels,
      showSelectAll: true,
    },
    {
      title: "Evaluation",
      filterKey: "selectedEvaluation",
      options: distinctEvaluations as string[],
      showSelectAll: true,
    },
    {
      title: "Status",
      filterKey: "selectedStatus",
      options: distinctStatus as string[],
      showSelectAll: true,
    },
    {
      title: "Product",
      filterKey: "selectedProduct",
      options: distinctProducts as string[],
      isSearchable: true,
      isVirtualized: true,
    },
    {
      title: "Sample ID",
      filterKey: "selectedSampleId",
      options: distinctSampleId as string[],
      isSearchable: true,
    },
  ];

  return (
    <Box data-testid="sidebar">
      <SidebarDrawer
        open={openSideBar}
        onToggle={toggleFilter}
        showApplyFilters={
          JSON.stringify(localFilter) !== JSON.stringify(selectedFilter) &&
          localFilter.startDate !== "" &&
          localFilter.endDate !== ""
        }
        applyFilters={applyFilters}
      >
        <DateRangeFilter setLocalFilter={setLocalFilter} />
        <Divider />
        {filterConfigs.map(({ title, filterKey, ...rest }) => (
          <GenericFilter
            key={filterKey}
            title={title}
            filterKey={filterKey}
            localFilter={localFilter}
            setLocalFilter={setLocalFilter}
            {...rest}
          />
        ))}
      </SidebarDrawer>
    </Box>
  );
};

export default SidebarContainer;
